import { BaseError } from './BaseError';

/**
 * クライアントエラー例外
 */
export class InvalidCredentialError extends BaseError {
}